import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Globe, Sparkles, Clock, MapPin } from 'lucide-react';

/**
 * Espace « Formations Pro » — catalogue des formations professionnelles.
 * Pour l'instant : « Création de sites Internet avec l'IA » (présentiel + en ligne).
 * D'autres formations seront ajoutées ici.
 */
export default function ProFormationsPage({ onBack, onOpenFormation }) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="max-w-5xl mx-auto px-4 py-10" data-testid="pro-formations-page">
      <button onClick={onBack} className="text-white/60 hover:text-white text-sm mb-6 flex items-center gap-1">
        <ChevronLeft size={16} />Retour
      </button>

      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 bg-blue-500/10 border border-blue-400/30 rounded-full px-4 py-1.5 text-xs text-blue-200 mb-4">
          <Sparkles size={12} />Mode académique · Formations professionnelles
        </div>
        <h1 className="text-3xl sm:text-5xl font-black tracking-tight">
          <span className="bg-gradient-to-r from-blue-300 via-purple-200 to-blue-200 bg-clip-text text-transparent">Formations Pro</span>
        </h1>
        <p className="text-white/70 mt-3 max-w-2xl mx-auto">
          Choisis la formation que tu souhaites suivre. Chaque formation peut se faire <strong>en présentiel</strong> ou <strong>en ligne</strong>, selon ta disponibilité.
        </p>
      </div>

      {/* Formation disponible : Création de sites avec l'IA */}
      <motion.button whileHover={{ y: -4 }} onClick={() => onOpenFormation('webai')} data-testid="pro-formation-webai"
        className="w-full text-left rounded-3xl p-8 bg-gradient-to-br from-blue-700 to-purple-800 relative overflow-hidden group mb-6">
        <div className="absolute -right-6 -bottom-6 text-9xl opacity-10 group-hover:opacity-20 transition">🌐</div>
        <Globe size={36} className="text-white/90 mb-4" />
        <div className="text-xs uppercase tracking-wider text-white/70">Formation accélérée · Web & apps · IA</div>
        <h3 className="text-2xl font-bold mt-1">Création de sites web et d'applications avec l'IA</h3>
        <p className="text-white/80 mt-2 text-sm max-w-xl">
          Formation accélérée : apprends à concevoir, développer et publier des sites web et des applications
          professionnels, de l'idée à la mise en ligne. L'IA t'accompagne pour accélérer.
        </p>
        <div className="flex flex-wrap gap-2 mt-4">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-white/15 backdrop-blur px-3 py-1.5 rounded-full"><Clock size={12} />10 heures · adaptable</span>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-white/15 backdrop-blur px-3 py-1.5 rounded-full"><MapPin size={12} />Présentiel ou en ligne</span>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-yellow-400 text-slate-900 px-3 py-1.5 rounded-full">Sur demande</span>
        </div>
        <div className="inline-flex items-center gap-1 mt-5 text-sm font-bold bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">
          Voir le programme<ChevronRight size={14} />
        </div>
      </motion.button>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-5 text-center">
        <div className="text-sm text-white/70">💡 D'autres formations professionnelles arrivent bientôt dans cet espace.</div>
      </div>
    </motion.div>
  );
}
